import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class WKBFromText extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.wkbfromtext',
        group: 'Parsers',
        title: 'WKB from Text',
        description: `
      This component creates a new column with geometries in WKB format created from the values
      in another column. This column should contain geometries defined in WKT string format.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'textcol',
          type: WorkflowComponentParamType.Column,
          title: 'Text column with geometries definition',
          parent: 'source',
          dataType: [ColumnDataType.String]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    return dedent`SELECT
      ${connection.processOutputGeogColumn(`ST_GEOMFROMTEXT(${params.textcol})`)}
      AS ${params.textcol}_geo, *
    FROM ${connection.quoteName(params.source as string)}`
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.textcol}_geo`,
      type: ColumnDataType.Binary
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.DatabricksRest]
  }
}

export { WKBFromText }
